export enum FILTER_NOTIFICATIONS {
  upcoming = 113,
  active = 114
}

export enum FILTER_SETTINGS {
  off = '0',
  light = '1',
  medium = '2',
  all = '3',
  custom = '4'
}

export const USER_PREFERENCE_PATH = '/user/preferences';
